import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import {autoPaginateSet} from "scenes/Survey/Structure/data/sets/actions";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';

class ModalAutoPagination extends Component {

  constructor(props) {
    super(props);

    this.state = {
      saving: false
    };
  }

  updateSet(){
    this.setState({saving: true});

    this.props.autoPaginateSet({
      id: this.props.set.id
    }).then(() => {
      this.setState({saving: false});
      this.props.toggleModal()
    });
  }

  render() {
    const {saving} = this.state;

    return <Modal isOpen={this.props.isOpen} toggle={this.props.toggleModal}>
      <ModalHeader toggle={this.props.toggleModal} tag="h2"><FormattedMessage id="set.headerActions.modalAutoPagination.cardHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <p><FormattedMessage id="set.headerActions.modalAutoPagination.cardBody" /></p>
      </ModalBody>
      <ModalFooter>
        <div className="direction-group d-flex justify-content-end">
          <div className="direction-right">
            <FormattedMessage id="_.button.yes">{
              (message) => <LaddaButton
                className="btn btn-primary btn-ladda mb-0 ml-3"
                loading={saving}
                data-style={ZOOM_OUT}
                onClick={() => this.updateSet()}
              >
                {message}
              </LaddaButton>
            }</FormattedMessage>

            <FormattedMessage id="_.button.cancel">{
              (message) => <Button color="secondary" className="mb-0 ml-3" onClick={this.props.toggleModal}>{message}</Button>
            }</FormattedMessage>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  }
}

ModalAutoPagination.propTypes = {
  set: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired
};

export default connect(null, {autoPaginateSet})(ModalAutoPagination);